export default __webpack_public_path__ + "static/media/index.5954e0ba.jpeg";